import {usePublicDownloadExpenseDocument} from 'api/expenses';
import {FileManagement} from 'components/ui/FileUpload/components/UploadedFile';
import {useState} from 'react';

export const usePublicExpenseFileManagement = (): FileManagement => {
    const [downloading, setDownloading] = useState<string[]>([]);
    const {mutate: downloadDocument} = usePublicDownloadExpenseDocument();

    const handleDownloadDocument = (_baseUrl: string, fileId?: string) => {
        if (!fileId) return;
        setDownloading(prev => [...prev, fileId.split('/').pop()!]);
        downloadDocument(
            {hash: fileId.split('/').pop()!},
            {
                onSettled: () =>
                    setDownloading(prev => prev.filter(p => p !== fileId)),
            },
        );
    };

    return {
        handleDownloadDocument,
        downloading,
        deleting: [],
        keyForDownload: 'hash',
    };
};
